//  ###########################################################################
//  ###########################################################################
//  assets/js-src/script-filter.js
{
    const init = () => {
        if (!$("#filter")) {
            return false; // beendet die Funktion, wenn es kein Element mit der ID = "filter" gibt
        } else {
            $("#filter").classList.add("js");
        }

        // set Label
        const select_elements = $$("#filter .settings .input select, #filter #starttime .input input, #filter #endtime .input input");
        for (const element of select_elements) {
            let selected_index;
            let selected_text;
            if (element.tagName === "SELECT") {
                selected_index = element.options.selectedIndex;
                console.log(selected_index);
                selected_text = element.options[selected_index].text;

            } else {
                selected_index = element.value.split(":")[0];
                console.log(selected_index);
                selected_text = element.value + " Uhr";
            }
            element.closest("div.settings").querySelector(".range input").value = selected_index;
            element.closest("div.input").querySelector("label").innerHTML = selected_text;

        }

        // register EventListener
        registerEvents($("#range-location_id"));
        registerEvents($("#range-offer_category_id"));
        registerEvents($("#range-target_group_id"));
        registerEvents($("#range-date_frequency"));
        registerEvents($("#range-date_weekday"));
        registerEvents($("#range-date_startdate"));
        registerEvents($("#range-date_enddate"));

        if ($("#range-date_starttime")) {
            $("#range-date_starttime").on("mousemove", changeTime);
            $("#range-date_starttime").on("touchmove", changeTime);
            $("#date_starttime").on("change", changeTimeWhithKeyboard);
        }
        if ($("#range-date_endtime")) {
            $("#range-date_endtime").on("mousemove", changeTime);
            $("#range-date_endtime").on("touchmove", changeTime);
            $("#date_endtime").on("change", changeTimeWhithKeyboard);
        }

    }

    const registerEvents = (selector) => {
        if (!selector) return false;
        selector.on("mousemove", changeSelection);
        selector.on("touchmove", changeSelection);
        selector.closest('.settings').querySelector('.input select').on("change", changeSelectionWhithKeyboard);
        selector.on("mousedown", displaySelection);
        selector.on("touchstart", displaySelection);
        selector.on("mouseup", hideSelection);
        selector.on("touchend", hideSelection);
        selector.on("mouseup", displayInput);
        selector.on("touchend", displayInput);
    }

    const hideSelection = (e) => {
        const id = e.currentTarget.id.split("-");
        if (id.length > 1) {
            $("#" + id[1]).classList.remove("active");
        } else {
            $("#input-" + id[0]).focus();
        }


    }

    const displaySelection = (e) => {
        const id = e.currentTarget.id;
        const select = id.split("-")[1];
        const length = $("#" + select).options.length;
        $("#" + select).classList.add("active");
        $("#" + select).size = length;
    }

    const changeSelectionWhithKeyboard = (e) => {
        console.log(e.target.options[e.target.selectedIndex].text);
        console.log(e.currentTarget.closest('.input'));
        const id = e.currentTarget.id;
        const select = id;
        const name = e.target.options[e.target.selectedIndex].text;
        e.target.closest('.input').querySelector('label').innerHTML = name;
        e.target.closest('.settings').querySelector('.range input').value = e.target.selectedIndex;
        if (name === "Datum") {
            $('#label-' + select).style.display = "none";
            $('#input-' + select).style.display = "block";
            $('#input-' + select).target = true;
            hideSelection(e);
        } else {
            $('#label-' + select).innerHTML = name;
            $('#label-' + select).style.display = "block";
            if ($('#input-' + select + '')) $('#input-' + select + '').style.display = "none";
        }
    }

    const changeSelection = (e) => {
        //console.log(e.currentTarget);
        const id = e.currentTarget.id;
        const select = id.split("-")[1];

        if ($("#" + select).options[e.currentTarget.value]) {
            $("#" + select).selectedIndex = e.currentTarget.value;
        }
    }

    const displayInput = (e) => {
        const id = e.currentTarget.id;
        const select = id.split("-")[1];

        if ($("#" + select).options[e.currentTarget.value]) {
            const name = $("#" + select).options[e.currentTarget.value].text;
            if (name === "Datum") {
                $('#label-' + select).style.display = "none";
                $('#input-' + select).style.display = "block";
            } else {
                $('#label-' + select).innerHTML = name;
                $('#label-' + select).style.display = "block";
                if ($('#input-' + select + '')) $('#input-' + select + '').style.display = "none";
            }

            $("#" + select).selectedIndex = e.currentTarget.value;
        }
    }

    const changeTimeWhithKeyboard = (e) => {
        //console.log(e.target.closest('.settings').querySelector('.range input'));
        e.target.closest('.input').querySelector('label').innerHTML = e.target.value;
        e.target.closest('.settings').querySelector('.range input').value = e.target.value.split(":")[0];
        console.log(e.target.value.split(":")[0]);
    }

    const changeTime = (e) => {
        const hour = "0" + e.currentTarget.value;
        const id = e.currentTarget.id;
        const select = id.split("-")[1];
        if (e.currentTarget.value === "24") {
            $('#label-' + select).innerHTML = "23:59 Uhr";
            $("#" + select).value = "23:59";
        } else {
            $('#label-' + select).innerHTML = hour.slice(-2) + ":00 Uhr";
            $("#" + select).value = hour.slice(-2) + ":00";
        }
    }


    // helper

    NodeList.prototype.__proto__ = Array.prototype;
    Node.prototype.on = function (name, fn) {
        this.addEventListener(name, fn);
        return this;
    };
    NodeList.prototype.on = NodeList.prototype.addEventListener = function (name, fn, wert) {
        this.forEach(elem => elem.on(name, fn, wert));
        return this;
    };

    const $ = document.querySelector.bind(document);
    const $$ = document.querySelectorAll.bind(document);

    init();
}

{
    // Auto-submit for filter-dropdowns.html: submit form on select change, swap results via fetch
    const filterHtml = document.querySelector('.filter-html[data-jem-ajax-results]');
    if (filterHtml) {
        const dropdownForm = filterHtml.querySelector('form');
        if (dropdownForm) {
            const resultsSelector = filterHtml.dataset.jemAjaxResults;

            const ajaxUrl = filterHtml.dataset.jemAjaxUrl;
            const pageId = filterHtml.dataset.jemPageId;

            // Every filter form on the page, calendar and dropdowns alike. Both templates mark
            // their form with jem-data-type, which is what makes them findable here.
            const jemForms = () => Array.from(
                document.querySelectorAll('form input[name="jem-data-type"]'),
                marker => marker.form
            ).filter(Boolean);

            // A filter can be split across the page: the calendar in one [jem_calendar], the
            // dropdowns in another. Each renders its own form and knows nothing of the other, so
            // without the two helpers below they overwrite each other's state.
            const otherForms = (primary) => jemForms().filter(other => other !== primary);

            // Pull the other forms' fields into this request -- the selected day above all. The
            // submitting form wins: the others' hidden fields still hold whatever the page was
            // rendered with, since ajax never reloads it.
            const addOtherFields = (formData, primary) => {
                otherForms(primary).forEach(other => {
                    new FormData(other).forEach((value, key) => {
                        if (!formData.has(key)) {
                            formData.append(key, value);
                        }
                    });
                });
            };

            // ...and push the submitting form's values back into the others, so a later plain
            // submit over there does not post the values the page happened to be rendered with.
            // Only fields they already have are updated; inventing new ones would couple the two
            // in ways the templates never asked for.
            const refreshOtherFields = (primary) => {
                const own = new FormData(primary);
                otherForms(primary).forEach(other => {
                    own.forEach((value, key) => {
                        other.querySelectorAll('input[type="hidden"][name="' + CSS.escape(key) + '"]')
                            .forEach(field => {
                                field.value = value;
                            });
                    });
                });
            };

            const MONTHS = ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli',
                'August', 'September', 'Oktober', 'November', 'Dezember'];

            // "2026-07-21", "2026-07-22" -> "21., 22. Juli"; across months the month name repeats,
            // e.g. "31. Juli, 1. August".
            const formatDays = (values) => {
                const groups = [];
                values.map(v => v.split('-').map(Number))
                    .sort((a, b) => a[0] - b[0] || a[1] - b[1] || a[2] - b[2])
                    .forEach(([y, m, d]) => {
                        const key = y + '-' + m;
                        let group = groups.find(g => g.key === key);
                        if (!group) {
                            group = {key, month: m, days: []};
                            groups.push(group);
                        }
                        group.days.push(d);
                    });

                return groups
                    .map(g => g.days.join('., ') + '. ' + MONTHS[g.month - 1])
                    .join(', ');
            };

            const dayBoxes = () => Array.from(document.querySelectorAll('input[name="days[]"]'));
            const zeitraumSelect = () => dropdownForm.querySelector('select[name="date_to_days"]');

            // After a submit that carried picked days, show them as the selected Zeitraum option and
            // lock the picked day boxes. Locked means a class, NOT the disabled attribute: a
            // disabled checkbox is left out of FormData, which would drop the day filter on the very
            // next submit. They stay checked and submittable, just not clickable (CSS).
            const reflectDays = () => {
                const checked = dayBoxes().filter(box => box.checked);

                dayBoxes().forEach(box => {
                    box.classList.toggle('jem-day-locked', box.checked);
                    const label = box.nextElementSibling;
                    if (label) {
                        label.classList.toggle('jem-day-locked', box.checked);
                    }
                });

                const select = zeitraumSelect();
                if (!select) {
                    return;
                }

                let option = select.querySelector('option[data-jem-days]');
                if (checked.length) {
                    if (!option) {
                        option = document.createElement('option');
                        option.dataset.jemDays = '1';
                        // Days take precedence in the query, so the value is display only.
                        option.value = '';
                        select.insertBefore(option, select.firstChild);
                    }
                    option.textContent = formatDays(checked.map(box => box.value));
                    option.selected = true;
                } else if (option) {
                    option.remove();
                }
            };

            // Picking a real Zeitraum range abandons the day selection: clear and unlock the days,
            // drop the synthetic option. Runs before the submit handler below, so the cleared state
            // is what gets posted.
            const select = zeitraumSelect();
            if (select) {
                select.addEventListener('change', () => {
                    const chosen = select.selectedOptions[0];
                    if (chosen && !chosen.dataset.jemDays) {
                        dayBoxes().forEach(box => {
                            box.checked = false;
                            box.classList.remove('jem-day-locked');
                            const label = box.nextElementSibling;
                            if (label) {
                                label.classList.remove('jem-day-locked');
                            }
                        });
                        const option = select.querySelector('option[data-jem-days]');
                        if (option) {
                            option.remove();
                        }
                    }
                });
            }

            // After a filter change on a long page the results can end up above the viewport, so
            // scroll the filter back into view. The theme header sticks to the top and would cover
            // it, so offset by the header's height. Measuring it while still scrolled up slightly
            // overestimates the pinned height (the header shrinks once pinned), which only leaves a
            // little extra gap -- the filter stays fully visible either way.
            const scrollToFilter = () => {
                const header = document.querySelector('.et-l--header');
                const offset = header ? header.getBoundingClientRect().height : 0;
                const top = filterHtml.getBoundingClientRect().top + window.pageYOffset - offset;

                window.scrollTo({top: Math.max(0, top), behavior: 'smooth'});
            };

            const submit = async (primary) => {
                const resultsEl = document.querySelector(resultsSelector);
                filterHtml.setAttribute('aria-busy', 'true');

                const formData = new FormData(primary);
                formData.set('action', 'jem_filter_results');
                formData.set('jem_page_id', pageId);

                addOtherFields(formData, primary);
                refreshOtherFields(primary);

                // The result element carries the attributes it was rendered with, so the handler
                // does not have to dig them back out of post_content. Re-validated server-side.
                if (resultsEl && resultsEl.dataset.jemAttributes) {
                    formData.set('jem_attributes', resultsEl.dataset.jemAttributes);
                }

                try {
                    const response = await fetch(ajaxUrl, {method: 'POST', body: formData});
                    if (!response.ok) return;
                    const html = await response.text();
                    if (resultsEl) {
                        resultsEl.innerHTML = html;
                        reflectDays();
                        scrollToFilter();
                    }
                } finally {
                    filterHtml.removeAttribute('aria-busy');
                }
            };

            // The page may already render with days checked (a full submit before the ajax took
            // over), so reflect that state once up front.
            reflectDays();

            // Dropdowns submit as soon as a select changes.
            dropdownForm.querySelectorAll('select').forEach(select => {
                select.addEventListener('change', () => submit(dropdownForm));
            });

            // Every filter form goes through ajax instead of reloading the page -- this is what
            // turns the calendar's "anzeigen" button into an ajax load. The submitting form is the
            // primary one, so the days a visitor just picked win over the other form's stale state.
            jemForms().forEach(jemForm => {
                jemForm.addEventListener('submit', event => {
                    event.preventDefault();
                    submit(jemForm);
                });
            });
        }
    }
}
